module.exports = (window.__NEXT_DATA__.assetPrefix || "").replace(/\/$/, "") + "/_next/static/images/crossword-promo-bcd0dafa50875a4173ff45a6241fa025.png";